import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { getRatings } from "../../redux/ratings/ratingSlice";
import { formatDate } from "../../helper/helper";
import PaginationHelper from "../../helper/PaginationHelper";

const RatingLayer = () => {

    const dispatch = useDispatch();

    const { ratings = [], total, totalPages } = useSelector(
        (state) => state.rating
    );

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50);
    const [search, setSearch] = useState("");

    useEffect(() => {
        dispatch(getRatings({ page, limit }));
    }, [dispatch, page, limit]);

    const filteredRatings = ratings.filter((r) =>
        r.from?.fullName?.toLowerCase().includes(search.toLowerCase()) ||
        r.to?.fullName?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="card h-100 p-0 radius-12">

            {/* HEADER */}

            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between">

                <div className="d-flex align-items-center gap-3">

                    <span className="text-md fw-medium text-secondary-light">
                        Show
                    </span>

                    <select
                        className="form-select form-select-sm w-auto"
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setPage(1);
                        }}
                    >
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="200">200</option>
                    </select>

                    <input
                        type="text"
                        className="form-control w-auto"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                </div>

            </div>

            {/* TABLE */}

            <div className="card-body">

                <table className="table bordered-table sm-table mb-0">

                    <thead>
                        <tr>
                            <th>#</th>
                            <th>From User</th>
                            <th>To User</th>
                            <th>Rating</th>
                            <th>Review</th>
                            <th>Date</th>
                        </tr>
                    </thead>

                    <tbody>

                        {filteredRatings.length > 0 ? (

                            filteredRatings.map((rating, index) => {

                                const ratingValue = Number(rating.rating || 0);

                                return (
                                    <tr key={rating.id}>

                                        <td>{(page - 1) * limit + index + 1}</td>

                                        {/* FROM USER */}
                                        <td>
                                            <div>
                                                <strong>{rating.from?.fullName}</strong>
                                                <br />
                                                <small className="text-secondary-light">
                                                    {rating.from?.email}
                                                </small>
                                            </div>
                                        </td>

                                        {/* TO USER */}
                                        <td>
                                            <div>
                                                <strong>{rating.to?.fullName}</strong>
                                                <br />
                                                <small className="text-secondary-light">
                                                    {rating.to?.email}
                                                </small>
                                            </div>
                                        </td>

                                        {/* RATING STARS */}
                                        <td>
                                            {[1, 2, 3, 4, 5].map((star) => (
                                                <Icon
                                                    key={star}
                                                    icon="mdi:star"
                                                    className={
                                                        star <= ratingValue
                                                            ? "text-warning"
                                                            : "text-secondary-light"
                                                    }
                                                />
                                            ))}
                                            <span className="ms-2 text-sm">
                                                ({ratingValue})
                                            </span>
                                        </td>

                                        {/* COMMENT */}
                                        <td style={{ maxWidth: "250px" }}>
                                            <div
                                                style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                }}
                                                title={rating.comment}
                                            >
                                                {rating.comment || "-"}
                                            </div>
                                        </td>

                                        {/* DATE */}
                                        <td>
                                            {formatDate(rating.createdAt)}
                                        </td>

                                    </tr>
                                );
                            })

                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center">
                                    No ratings found
                                </td>
                            </tr>
                        )}

                    </tbody>

                </table>

                {/* PAGINATION */}
                <PaginationHelper
                    currentPage={page}
                    totalPages={totalPages}
                    onPageChange={setPage}
                    totalItems={total}
                    pageSize={limit}
                />

            </div>

        </div>
    );
};

export default RatingLayer;